const staff = {
    namespaced: true,

    state: {
        staffId: null
    },

    getters: {
        getStaffId(state) {
            return state.staffId;
        }
    },

    mutations: {
        SET_STAFF_ID(state, id) {
            state.staffId = id;
        }
    },

    actions: {
        setStaffId(context, id) {
            context.commit('SET_STAFF_ID', id);
        }
    }
};

export default staff;